import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { profileVerified } from "assets";
import ImageUrlProfile from "components/app/image-url/ImageUrlProfile";
import LinkifyText from "components/app/linkify/LinkifyText";
import { commentTimeAgo } from "utils/formatTimeSecondToHour";
import { Textarea } from "components/ui/textarea";
import { faHeart as solidHeart } from "@fortawesome/free-solid-svg-icons";
import { faFaceSmileBeam, faHeart as outlineHeart } from "@fortawesome/free-regular-svg-icons";
import { useEffect, useRef, useState } from "react";
import EmojiPicker, { EmojiClickData, EmojiStyle } from "emoji-picker-react";
import { Ellipsis, SendHorizontalIcon, Sticker, Trash2, X } from "lucide-react";
import StickerPicker from "./Stickers";
import { MessageType } from "utils/enum/message_type";
import { Service } from "utils/services";
import DailogDeleteComments from "pages/profile/dialog/DailogDeleteComments";
import { Popover, PopoverContent, PopoverTrigger } from "@radix-ui/react-popover";
import { RequestApi, RouteApi, StatusMsg } from "utils";
import { AppLog } from "services";
import { useAppSelector } from "store/store";
import { profilePostContentStore } from "store/profilePostContentStore";
import { useViewPostContentStore } from "store/useViewPostContentStore";

interface CommentProps {
  comment: any;
  index: number;
  replyingTo: number;
  onReplyClick: (commentId: number) => void;
  submitReply: ({ replyId, replyText, commentId, commentUrl }: { replyId: string; replyText: string; headerId: string; commentId: string; commentUrl: string }) => void;
  fetchSubComments?: (commentId: string, nextPageUrl?: string) => void;
  onClikcReact: (comment: any) => void;
  children?: React.ReactNode;
  isSubComment?: boolean;
}

export default function Comment({ comment, index, submitReply, fetchSubComments, onClikcReact, onReplyClick, children, isSubComment, replyingTo }: CommentProps) {
  const [replyText, setReplyText] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [showStickerPicker, setShowStickerPicker] = useState(false);
  const stickerPickerRef = useRef<HTMLDivElement>(null);
  const emojiPickerRef = useRef<HTMLDivElement>(null);
  const [sticker, setSticker] = useState<any>({});
  const onEmojiClick = (emojiData: EmojiClickData) => {
    setReplyText((prev) => prev + emojiData.emoji);
  };

  const handleSubmitReply = ({ replyId, headerId, commentId }: { replyId: string; headerId: string; commentId: string }) => {
    submitReply({
      replyId: replyId,
      replyText: replyText,
      headerId: headerId,
      commentId: commentId,
      commentUrl: Object.keys(sticker).length === 0 ? "" : sticker.thumbnail_url,
    });

    setReplyText("");
    setSticker({});
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (replyText) {
        handleSubmitReply({
          replyId: fetchSubComments ? comment.id.toString() : comment.reply_comment_id.toString(),
          headerId: comment.reply_comment_id.toString(),
          commentId: comment.comment_id,
        });
      }
    }
  };

  const { token } = useAppSelector((state) => state.auth);

  // todo : JK - i check see this need to update
  // const { comments, setComments, currentPost: post } = useViewPostContentStore();
  const { comments, setComments, post } = profilePostContentStore.getState();

  const onSubmitDeleteComments = async (id: any) => {
    try {
      let url: string = "";
      url = RouteApi.submitDeleteComment;
      url += `token=${token}`;
      const data = {
        comment_id: id,
      };
      await RequestApi(url, { data })
        .then((responses) => {
          setComments(comments.filter((comment: any) => comment.comment_id !== id));
        })
        .catch((err) => {});
    } catch (error) {
      AppLog.show({
        message: `[onSubmitDeleteComments]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target as Node)) {
        setShowEmojiPicker(false);
      }
      if (stickerPickerRef.current && !stickerPickerRef.current.contains(event.target as Node)) {
        setShowStickerPicker(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [dailogDeleteComment, setDailogDeleteComent] = useState<any>(false);
  const { userAuth } = useAppSelector((state) => state.auth);

  return (
    <div className="flex flex-col mt-2 mb-2   ">
      <DailogDeleteComments setDailogDeleteComent={setDailogDeleteComent} dailogDeleteComment={dailogDeleteComment} />
      <div key={index} className="flex flex-row space-x-2 w-full items-start justify-start">
        <ImageUrlProfile isLinkProfile={true} user={comment.sender} className={`cursor-pointer rounded-full ${isSubComment ? " w-7 h-7" : " w-7 h-7"}`} alt="logo" />
        <div className="flex flex-col space-y-2 w-full">
          <div className="flex items-center gap-3 group  w-[190px]">
            <div className={`flex flex-col   rounded-lg  py-1 self-start w-auto ${comment.comment !== "" && comment.comment ? "dark:bg-[#3A3B3C] bg-gray-200  px-2" : ""}`}>
              <p className="flex flex-row font-medium items-center text-sm">
                {`${comment.sender?.name!}`}
                {comment.sender?.is_verified === "Yes" ? (
                  <>
                    <img
                      src={profileVerified}
                      alt=""
                      className="ml-1"
                      style={{
                        width: 10,
                        height: 10,
                      }}
                    />
                  </>
                ) : (
                  <></>
                )}
              </p>

              {comment.comment !== "" && comment.comment ? <LinkifyText key={comment.comment_id} text={comment.comment} /> : <></>}
            </div>
            {comment.comment_user_id === userAuth.id || post.account_id === userAuth.account_id ? (
              <div className="opacity-0 group-hover:opacity-100">
                <Popover>
                  <PopoverTrigger asChild>
                    <div className="flex w-8 h-8 rounded-full bg-[#f4f7fa] dark:bg-[#182334] text-center items-center justify-center cursor-pointer ">
                      <Ellipsis className=" cursor-pointer" />
                    </div>
                  </PopoverTrigger>
                  <PopoverContent
                    onClick={() => {
                      onSubmitDeleteComments(comment.comment_id);
                    }}
                    className=" w-[200px] border border-gray-200 absolute left-[30px] p-2 bg-popover z-50 gap-3 items-start px-3 py-2 rounded-md hover:bg-accent"
                  >
                    <div className="flex items-center gap-3 cursor-pointer ">
                      <div className="flex justify-center items-center h-[40px]">
                        <Trash2 className="text-red-500" />
                      </div>
                      <div className="flex flex-col">
                        <span className="font-medium leading-none">Delete</span>
                        <span className="text-sm text-muted-foreground">Delete your comment.</span>
                      </div>
                    </div>
                  </PopoverContent>
                </Popover>
              </div>
            ) : (
              ""
            )}
          </div>
          {comment["id"] === 0 ? (
            <p className="text-sm text-gray-400">Posting...</p>
          ) : (
            <>
              {MessageType.getType(comment.comment_type) === MessageType.sticker ? <img src={comment.comment_url} alt="sicker" className="w-16 h-16" /> : <></>}
              <div className="flex flex-row space-x-3 items-center">
                <p className="font-medium text-xs ">{commentTimeAgo(comment.comment_datetime)}</p>
                <p className="cursor-pointer font-medium text-xs" onClick={() => onReplyClick(comment.id)}>
                  Reply
                </p>
                <FontAwesomeIcon
                  onClick={() => onClikcReact(comment)}
                  icon={comment["is_like"]?.toString() === "1" ? solidHeart : outlineHeart}
                  size="1x"
                  className={` ${comment["is_like"]?.toString() === "1" ? "heart-icon text-red-600 heart-fill" : "heart-outline outline-black"}`}
                />

                {comment.no_of_reply_comment > 0 && !comment["sub_comments"] ? (
                  <p
                    className=" cursor-pointer text-yellow-500 font-medium text-xs"
                    onClick={() => fetchSubComments!(comment.id.toString(), comment["sub_comments"]?.next_page_url)}
                  >{`View ${comment.no_of_reply_comment} ${comment.no_of_reply_comment === 1 ? "reply" : "replies"} `}</p>
                ) : (
                  <>
                    {comment["sub_comments"] ? (
                      <p
                        className=" cursor-pointer text-yellow-500 font-medium text-xs"
                        onClick={() => fetchSubComments!(comment.id.toString(), comment["sub_comments"].next_page_url)}
                      >
                        {comment["sub_comments"].data.length < comment.no_of_reply_comment
                          ? ` View more ${comment.no_of_reply_comment - comment["sub_comments"].data.length} ${comment.no_of_reply_comment === 1 ? "reply" : "replies"}`
                          : ""}
                      </p>
                    ) : (
                      <></>
                    )}
                  </>
                )}
              </div>
            </>
          )}

          {replyingTo === comment.id && (
            <div className=" flex flex-col space-y-2">
              <div key={index} className="flex flex-row space-x-2 w-full items-start justify-start">
                <ImageUrlProfile isLinkProfile={true} user={Service?.userAuth} className={`cursor-pointer rounded-full ${isSubComment ? " w-7 h-7" : " w-7 h-7"}`} alt="logo" />
                <div className="border p-2 relative z-1 rounded-md w-full dark:bg-[#3A3B3C]">
                  <div className="flex flex-col">
                    <Textarea
                      value={replyText}
                      onKeyDown={handleKeyDown}
                      onChange={(e) => setReplyText(e.target.value)}
                      className="border border-none min-h-[10px]  focus-visible:ring-0 focus-visible:ring-offset-0 w-full  px-0 py-0 rounded-none dark:bg-[#3A3B3C]"
                      placeholder="Write your reply..."
                    />
                    <div className="flex justify-between items-center">
                      <div className="flex space-x-2 items-center z-50">
                        <Popover>
                          <PopoverTrigger asChild>
                            <div className="flex w-8 h-8 rounded-full  bg-gray-200 text-center items-center justify-center">
                              <FontAwesomeIcon
                                icon={faFaceSmileBeam}
                                className="text-gray-700 dark:text-gray-500 cursor-pointer size-5"
                                onClick={() => setShowEmojiPicker((prev) => !prev)}
                              />
                            </div>
                          </PopoverTrigger>
                          <PopoverContent className="w-92">
                            <div ref={emojiPickerRef} className="absolute bottom-[0px] left-0 z-[100px]" spellCheck={false}>
                              <EmojiPicker
                                reactionsDefaultOpen={false}
                                onEmojiClick={onEmojiClick}
                                emojiStyle={EmojiStyle.FACEBOOK}
                                searchDisabled={true}
                                skinTonesDisabled={true}
                              />
                            </div>
                          </PopoverContent>
                        </Popover>
                        <Popover>
                          <PopoverTrigger asChild>
                            <div className="flex w-8 h-8 rounded-full  bg-gray-200 text-center items-center justify-center">
                              <Sticker className=" text-gray-700 dark:text-gray-500 font-extrabold cursor-pointer size-5" onClick={() => setShowStickerPicker(true)} />
                            </div>
                          </PopoverTrigger>
                          <PopoverContent className="w-92">
                            {showStickerPicker && (
                              <StickerPicker
                                stickerPickerRef={stickerPickerRef}
                                onStickerSelect={(sticker) => {
                                  setShowStickerPicker(false);

                                  setSticker(sticker);
                                }}
                              />
                            )}
                          </PopoverContent>
                        </Popover>
                      </div>

                      <div className="flex w-8 h-8 rounded-full  bg-gray-200 text-center items-center justify-center">
                        <SendHorizontalIcon
                          className={`cursor-pointer ${replyText || Object.keys(sticker).length !== 0 ? "text-yellow-400" : "text-gray-500 dark:text-gray-500"}`}
                          onClick={
                            !replyText && Object.keys(sticker).length === 0
                              ? () => {}
                              : () =>
                                  handleSubmitReply({
                                    replyId: fetchSubComments ? comment.id.toString() : comment.reply_comment_id.toString(),
                                    headerId: comment.reply_comment_id.toString(),
                                    commentId: comment.comment_id,
                                  })
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {Object.keys(sticker).length !== 0 ? (
                <div className="relative sticker-image w-16 h-16">
                  <img src={sticker.thumbnail_url} alt={sticker.pack_name} />
                  <div
                    className="absolute bg-gray-200 -top-1 -right-2 w-5 h-5 rounded-full dark:bg-[#3A3B3C] flex items-center cursor-pointer justify-center hover:bg-gray-300 hover:dark:bg-[#4E4F50]"
                    onClick={() => setSticker({})}
                  >
                    <X className="w-4 h-4 " />
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
          )}
          {children ? children : <></>}
        </div>
      </div>
    </div>
  );
}
